import { render, staticRenderFns } from "./SettlementsExpenses.vue?vue&type=template&id=350cb6e9&"
import script from "./SettlementsExpenses.vue?vue&type=script&lang=js&"
export * from "./SettlementsExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports